const offerName = ({ make = '', model = '', part_name = '', title = '', production_year = '', data = {}}) =>
    [part_name || title || `${make} ${model}`,
        data.body_type || data.truck_body_type,
        production_year]
    .filter(Boolean)
    .join(' ')

module.exports = offerName